import { Box } from "@mui/material";

export function PageWrapper({ children, toolbar = null, sx = {} }) {
  return (
    <Box
      component="main"
      sx={{
        width: "100%",
        minWidth: 0,
        p: { xs: 0.75, sm: 1, lg: 1.25 },
        flex: 1,
        ...sx,
      }}
    >
      <Box
        sx={{
          display: "flex",
          width: "100%",
          minWidth: 0,
          flexDirection: "column",
          gap: 0.75,
        }}
      >
        {toolbar}
        {children}
      </Box>
    </Box>
  );
}
